export default (axios) => axios.get('/available-payout-amounts');
